module.exports = "<!doctype html> <html xmlns:o=urn:schemas-microsoft-com:office:office xmlns:w=urn:schemas-microsoft-com:office:word xmlns=http://www.w3.org/TR/REC-html40> <head> <style type=text/css>@page{size:21cm 29.7cm;margin:2cm}body,h1,h2,h3,h4,h5,h6{font-family:sans-serif}body{font-size:8pt;text-align:justify}td,th,tr{text-align:left}h3{margin-top:1cm}.text-muted,small{font-size:6pt}table{border-collapse:collapse}.table,table,td,th{padding:.2em}</style> <meta charset=utf-8> <title>[TITLE]</title> </head> <body>[HTML]</body> </html> ";


//////////////////
// WEBPACK FOOTER
// ./resources/js/data/WordTemplate.html
// module id = oqnz
// module chunks = 97